import { render, staticRenderFns } from "./TagsModal.vue?vue&type=template&id=b87c1faa&scoped=true&"
import script from "./TagsModal.vue?vue&type=script&lang=js&"
export * from "./TagsModal.vue?vue&type=script&lang=js&"
import style0 from "./TagsModal.vue?vue&type=style&index=0&id=b87c1faa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b87c1faa",
  null
  
)

export default component.exports